import {Register} from "../fstn/register";
import {Cursor} from "../fstn/cursor";

export interface CursorHistoryRecord {
    state: string
    registers: Map<string, Register>
}
export class CursorHistory {
    private states: CursorHistoryRecord[] = [];

    public PushState(cursor: Cursor) {
        const state = cursor.state;
        const registers = new Map<string, Register>();

        cursor.registers.forEach((register, key) =>
            registers.set(key, new Register(register.serialise())));
        this.states.push({state, registers});
    }
    public PopState() : (CursorHistoryRecord | undefined) {
        return this.states.pop();
    }
    public Reset(cursor: Cursor) {
        this.states.length = 0;
        this.PushState(cursor);
    }
}